// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3YY9e","consentsList":"PatientConsents_consentsList__3J81a","consentsListEmpty":"PatientConsents_consentsListEmpty__1FqjU"};